import { formatHtml } from "@trumpf/ux.common-storybook";
import { VideoSliderTemplate } from "./video-slider.templates";

export default {
    title: "Website/Page Templates/Search/Search Results Sliders/Video Slider",
    render: VideoSliderTemplate.bind({}),
    tags: ["autodocs"],
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const VideoSlider = {};
